<template>
  <v-container>
    <v-checkbox
      v-model="vesselControl"
      :label="$t('vessel_monitored')"
    ></v-checkbox>
    <v-select
      v-if="vesselControl"
      :items="controlType"
      :item-text="item => $t(item.text)"
      item-value="value"
      v-model="vesselControlType"
      :label="$t('type_of_control')"
    ></v-select>
  </v-container>
</template>

<script>
import { maocData } from '../../services/MaocData'

export default {
  name: 'VesselControl',
  data: vm => ({
    vesselControl: false,
    vesselControlType: '',
    controlType: maocData.asLocalizedSelect('controlType')
  }),
  methods: {
    getData: function () {
      var exportData = {}
      if (this.vesselControl) {
        exportData.vesselControl = this.vesselControl
        exportData.vesselControlType = this.vesselControlType
        exportData.vessel_control_type_en = this.$t(this.vesselControlType, 'en')
      }
      return exportData
    },
    setData: function (data) {
      if (data) {
        this.vesselControl = data.vesselControl
        this.vesselControlType = data.vesselControlType
      }
    }
  }
}
</script>
